import AuthLayout from "../../layout/admin/AuthLayout";
import AdminLogin from "../../view/admin/auth/AdminLogin";
import AdminPublicRoute from "./adminPublicRoute";

const adminAuthRouter = {
  path: "/admin/auth",
  element: (
    <AdminPublicRoute>
      <AuthLayout />
    </AdminPublicRoute>
  ),
  children: [
    {
      path: "/admin/auth",
      element: (
        <AdminPublicRoute>
          <AdminLogin />
        </AdminPublicRoute>
      ),
    },
  ],
};

export default adminAuthRouter;
